
  import { Vue, Component } from 'vue-property-decorator';
  import { types } from '@/store';
  import { data } from './mc-meal-wizard.data';

  @Component
  export default class McMealWizardTests extends Vue {
    created() {
      this.$store.dispatch(types.actions.updateCountDto, data.mealCount);
    }

    mounted() {
    }
  }
